import React from 'react'
import ProgressBar from '../ProgressBar';
import logo from '../../img/logo2.png'
import { Image } from 'react-bootstrap';
import './nav.css'
const Nav = () => {
  return (
    <div id="nav">
        <div id='header'className='p-2'>
            <div className='' id='img-nav'>
                <a href="/"><Image src={logo} fluid  /></a>
            </div>
            <div id='divp' className='flex-end p-3'>
            <ProgressBar progress={100}/>
            {/* <ProgressBar variant='' now={100} style={{height:5, backgroundColor:'red'}} className="custom-progress-bar" /> */}
                <p >PLATEFORME DE DEPÔT DE DOSSIERS </p>
            </div>
        </div>
    </div>
  )
}

export default Nav